import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { AlertTriangle } from "lucide-react";

export function TickerWarningBadge({ ticker, warning }) {
    if (!warning) return null;
    return (
        <TooltipProvider delayDuration={100}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span onClick={(e) => e.stopPropagation()}
                        className="inline-flex items-center gap-0.5 rounded px-1 py-0.5 text-[9px] font-semibold uppercase tracking-wider bg-loss/15 text-loss border border-loss/30"
                        data-testid={`ticker-warning-${ticker}`}>
                        <AlertTriangle className="w-2.5 h-2.5" />Old ticker
                    </span>
                </TooltipTrigger>
                <TooltipContent className="max-w-[280px] text-xs whitespace-normal">{warning}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
